import React, { useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { HiArrowUpRight } from "react-icons/hi2";

export default function Login() {
  const { user, loading, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  if (loading) return null;
  if (user) {
    const target = loc.state?.from || "/admin";
    return <Navigate to={target} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (e2) {
      setError(e2?.response?.data?.error || e2.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <span className="eyebrow">Admin</span>
        <h1 style={{ marginTop: 8 }}>Sign in to the studio</h1>
        <p>Manage drafts, generate posts with AI, and ship when ready.</p>

        <div className="field">
          <label htmlFor="u">Username</label>
          <input
            id="u"
            className="input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
        </div>
        <div className="field">
          <label htmlFor="p">Password</label>
          <input
            id="p"
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <button type="submit" className="btn btn--lg" disabled={busy} style={{ width: "100%", justifyContent: "center" }}>
          {busy ? "Signing in…" : "Sign in"}
          <span className="arrow"><HiArrowUpRight /></span>
        </button>

        {error && <div className="error-msg">{error}</div>}
      </form>
    </div>
  );
}
